import Popup from '@/components/Popup';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import Popper from '@mui/material/Popper';
import { useEffect, useState } from 'react';

interface Props {
  open: boolean;
  anchorEl: HTMLElement;
  phoneList: any[];
  onClose: () => void;
  handleApply: (item: any) => void;
  telephoneData: string;
  onPhoneChange?: (newTelephoneData: string) => void;
}

export const PhoneListComponent = (props: Props) => {
  const { open, anchorEl, phoneList, handleApply, onClose, telephoneData, onPhoneChange } = props;

  // 解析 telephoneData，格式如: "US(+1)(213)123-1111" 或 "US(+1) 1234567890"
  const parseTelephoneData = (data: string) => {
    if (!data) return { countryCode: '', phoneNumber: '' };

    // 匹配格式: "US(+1)(213)123-1111" 或 "US(+1) 1234567890"
    const match = data.match(/^([A-Z]+\(\+\d+\))\s*(.*)$/);
    if (match) {
      return {
        countryCode: match[1], // "US(+1)"
        phoneNumber: match[2].trim(), // "(213)123-1111" 或 "1234567890"
      };
    }

    return { countryCode: data, phoneNumber: '' };
  };

  const { countryCode, phoneNumber: initialPhoneNumber } = parseTelephoneData(telephoneData);
  const [phoneNumber, setPhoneNumber] = useState(initialPhoneNumber);

  // 当 telephoneData 变化时更新本地状态
  useEffect(() => {
    const { phoneNumber: newPhoneNumber } = parseTelephoneData(telephoneData);
    setPhoneNumber(newPhoneNumber);
  }, [telephoneData]);

  // 处理输入框变化
  const handlePhoneInputChange = (value: string) => {
    setPhoneNumber(value);
    // 通知父组件数据变化
    if (onPhoneChange) {
      const newTelephoneData = `${countryCode}${value ? ` ${value}` : ''}`;
      onPhoneChange(newTelephoneData);
    }
  };

  // 获取最大长度限制
  const getMaxLength = () => {
    return countryCode.includes('US(+1)') ? 13 : 15;
  };

  return (
    <>
      <WebOnly>
        <Popper
          open={open}
          anchorEl={anchorEl}
          placement="bottom-start"
          sx={{
            width: anchorEl?.clientWidth,
            zIndex: 999,
          }}
        >
          <div className="relative bg-white rounded-[10px] border border-[#E0E0E0] p-10 max-h-[300px] overflow-y-auto z-999">
            {phoneList.map((item) => (
              <div key={item.id} className="cursor-pointer p-8 " onClick={() => handleApply(item)}>
                {item.label}
              </div>
            ))}
          </div>
        </Popper>
      </WebOnly>

      <WapOnly>
        <Popup
          open={open}
          onClose={onClose}
          position="bottom"
          showDivider={false}
          height="76vh"
          title="Phone"
          sx={{
            '& .popup-content': {
              padding: '0',
              backgroundColor: '#f5f5f5',
            },
            '& .popup-title': {
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          <div className="mx-14 mb-12 h-[42px] bg-white rounded-[10px] flex items-center ">
            <div className="flex items-center space-x-2 w-full">
              <span className="text-[14px] mr-8 border-r border-[#E0E0E0] py-8 px-12">
                {countryCode}
              </span>
              <input
                type="tel"
                value={phoneNumber}
                onChange={(e) => handlePhoneInputChange(e.target.value)}
                maxLength={getMaxLength()}
                placeholder="You can input it here or select it below"
                className="flex-1 text-[14px] border-none outline-none bg-transparent placeholder-gray-400 w-full"
              />
            </div>
          </div>

          <div className=" overflow-y-auto px-14">
            {phoneList.map((item) => (
              <div
                key={item.id}
                className="cursor-pointer py-[5.3vw]  text-[14px] border-t border-[#E0E0E0]"
                onClick={() => handleApply(item)}
              >
                {item.label}
              </div>
            ))}
          </div>
        </Popup>
      </WapOnly>
    </>
  );
};
